import React from "react";
import {withStyle} from "../../hoc/bridge.hoc.js";
import {cmpClassName} from "../../common/generic-react.functions.js";
import {MaintenanceMainContainer, MaintenanceContainer, LogoContainer, ImageContainer, ContentContainer, TextContainer, TitleContainer, SubTitleContainer} from "./maintenance.styles.js";
import {useTranslation} from "../../../__snowpack__/link/packages/old-i18n/dist/i18n.esm.js";
function MaintenancePage() {
  const {
    t
  } = useTranslation();
  return /* @__PURE__ */ React.createElement(MaintenanceMainContainer, {
    className: cmpClassName("maintenance-page"),
    color: "var(--primaryColor)"
  }, /* @__PURE__ */ React.createElement(MaintenanceContainer, null, /* @__PURE__ */ React.createElement(LogoContainer, null, /* @__PURE__ */ React.createElement("img", {
    src: "/img/logo_new_one.svg",
    alt: "logo"
  })), /* @__PURE__ */ React.createElement(ContentContainer, null, /* @__PURE__ */ React.createElement(TextContainer, null, /* @__PURE__ */ React.createElement(TitleContainer, null, t("maintenance.content.title")), /* @__PURE__ */ React.createElement(SubTitleContainer, null, t("maintenance.content.subtitle"))), /* @__PURE__ */ React.createElement(ImageContainer, null, /* @__PURE__ */ React.createElement("img", {
    src: "/img/maintenance.png",
    alt: "maintenance"
  })))));
}
export default /* @__PURE__ */ React.memo(withStyle(MaintenancePage));
